import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Add this for navigation
import './QrForm.css';

const QrForm = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);
  const [orderType, setOrderType] = useState('individual');
  const [groupSize, setGroupSize] = useState('');
  const [familySize, setFamilySize] = useState('');
  const [message, setMessage] = useState('');
  const [showSpinWheel, setShowSpinWheel] = useState(false);
  const [spinResult, setSpinResult] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [cartError, setCartError] = useState('');
  const [fetchError, setFetchError] = useState('');
  const [offers, setOffers] = useState([]);
  const [offersError, setOffersError] = useState('');
  const [wonOffer, setWonOffer] = useState(null); // New state for won offer
  const canvasRef = useRef(null);
  const [spinning, setSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);

  const colors = ['#FF6F61', '#FFD700', '#6AB04C', '#3498DB'];

  // ... (useEffect for fetchProducts and fetchOffers remains the same)

  const handleSubmitOrder = () => {
    const filteredCart = cart.filter(item => item.quantity > 0);
    if (filteredCart.length === 0) {
      setCartError('Please select at least one product.');
      return;
    }

    const orderData = {
      cart: filteredCart,
      orderType,
      groupSize: orderType === 'group' ? groupSize : null,
      familySize: orderType === 'family' ? familySize : null,
      mobileNumber,
    };

    axios.post('http://localhost:5002/api/qrpage/calculate-price', orderData)
      .then(response => {
        const { totalPrice, offer } = response.data;
        setTotalPrice(totalPrice);
        setMessage(`Order placed successfully! Total Price: ₹${totalPrice}, Offer: ${offer}`);
        setCartError('');
        // Navigate to SpinWheel with cart and mobile number
        navigate('/spin-wheel', { state: { offerItems: offers, mobileNumber } });
      })
      .catch(error => {
        console.error('Error placing order:', error);
        setMessage(error.response?.data?.message || 'Failed to place order.');
      });
  };

  // Handle return from SpinWheel
  useEffect(() => {
    if (wonOffer) {
      const finalizeOrder = () => {
        const filteredCart = cart.filter(item => item.quantity > 0);
        const orderData = {
          cart: filteredCart,
          orderType,
          groupSize: orderType === 'group' ? groupSize : null,
          familySize: orderType === 'family' ? familySize : null,
          mobileNumber,
          offer: wonOffer, // Include won offer
        };

        axios.post('http://localhost:5002/api/qrpage/calculate-price', orderData)
          .then(response => {
            const { totalPrice, offer } = response.data;
            setTotalPrice(totalPrice);
            setSpinResult(`Congratulations! You won: ${offer}`);
            setMessage(`Order finalized! Total Price: ₹${totalPrice}, Offer: ${offer}`);
          })
          .catch(error => {
            console.error('Error finalizing order:', error);
            setMessage(error.response?.data?.message || 'Failed to finalize order.');
          });
      };
      finalizeOrder();
      setWonOffer(null); // Reset after use
    }
  }, [wonOffer, navigate, cart, orderType, groupSize, familySize, mobileNumber]);

  // ... (drawWheel, handleSpin, handleSendOtp, handleVerifyOtp, handleProductSelect, handleQuantityChange remain the same)

  const isCartEmpty = !cart.some(item => item.quantity > 0);

  return (
    <div className="qr-form-wrapper">
      <div className="qr-form-container">
        <h2>Place Your Order</h2>
        {/* ... (OTP and order section remains the same) */}
        {message && !showSpinWheel && !spinResult && <p className="message">{message}</p>}
        {spinResult && <p className="spin-result">{spinResult}</p>}
      </div>
    </div>
  );
};

export default QrForm;